import Grid from "@mui/material/Unstable_Grid2";
import Button from "@mui/material/Button";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Slider from "@mui/material/Slider";
import Typography from "@mui/material/Typography";
import { Close } from "@mui/icons-material";
import { format } from "date-fns";
import { useCallback, useEffect, useState } from "react";
import { DatePicker } from "../../components/DatePicker";
import { MES, SN, TERMOMETRO } from "../../utils/helpers/Constants";
import { RemoveAcentos } from "../../utils/helpers/Format";
import DialogFilterSave from "./DialogFilterSave";
import { useFormikContext } from "formik";
import { useQuery, useMutation } from "react-query";
import {
  listStores,
  listAllProfession,
  listAllCategories1,
  listAllCategories2,
  listAllCategories3,
  listAllCategories4,
  listAllCategories5,
  listAllCategories6,
  listAllCategories7,
  listAllCategories8,
  listAllCategories9,
  listAllCategories10,
  listTagOrigin,
  saveListProspecsPF,
  listAllDocuments,
  listConsumptionProfile,
  listOverviewDDD,
} from "../../services/insights";
import {
  listUFsGet,
  listMunicipalities,
  listNeighborhoods,
} from "../../services/sellMore";
import getFilterData from "./getFilterData";
import { useToast } from "../../hooks/useToast";
import { useStyles } from "./styles";
import { Autocomplete } from "../../components/Autocomplete";
import { isEmpty, map } from "lodash";
import { useDialogConfirmation } from "../../hooks/useDialogConfirmation";
import { useNavigate } from "react-router-dom";
import { useAudience } from "../../hooks/useAudience";

export const ordenaArray = (array, prop) =>
  array.sort((a, b) => {
    if (a[prop] > b[prop]) return 1;
    if (a[prop] < b[prop]) return -1;
    return 0;
  });

function Filtro({ showFormikFilter, setShowFormikFilter, children }) {
  const styles = useStyles();

  const dialog = useDialogConfirmation();
  const navigate = useNavigate();
  const [state, setStateMore] = useState({
    modalSalvarFiltro: false,
    filterName: "",
    clusterName: null,
  });

  const setState = (obj) => {
    setStateMore((prev) => ({
      ...prev,
      ...obj,
    }));
  };

  const formik = useFormikContext();

  const changeFiltro = (label, value) => {
    formik.setFieldValue(label, value);
  };

  const {
    selectedEstados,
    selectedMunicipios,
    selectedBairros,
    selectedDDD,
    faixaEtaria,
    percentualDesconto,
    genre,
    status,
    termometro,
    selectedDocumento,
    selectedTagOrigem,
    selectedProfissao,
    selectedMesNascimento,
    dataCompraInicio,
    dataCompraFim,
    dataCadastroInicio,
    dataCadastroFim,
    categoria_1,
    categoria_2,
    categoria_3,
    categoria_4,
    categoria_5,
    categoria_6,
    categoria_7,
    categoria_8,
    categoria_9,
    categoria_10,
    categoria_11,
    categoria_12,
    n_categoria_1,
    n_categoria_2,
    n_categoria_3,
    n_categoria_4,
    n_categoria_5,
    n_categoria_6,
    n_categoria_7,
    n_categoria_8,
    n_categoria_9,
    n_categoria_10,
    pesquisa_1,
    pesquisa_2,
    pesquisa_3,
    pesquisa_4,
    pesquisa_5,
    celular,
    telefone,
    endereco,
    aniversarioHoje,
    aniversarioMes,
    email,
    valorComprasInicio,
    valorComprasFim,
    qtdeComprasInicio,
    qtdeComprasFim,
    ticketMedioInicio,
    ticketMedioFim,
    diasCadastroInicio,
    diasCadastroFim,
    diasCompraInicio,
    diasCompraFim,
    cashbackInicio,
    cashbackFim,
    dataInicioVencimentoCashback,
    dataFimVencimentoCashback,
    diasVencimentoCashback,
    selectedStores,
    canalPreferecia,
    canalAceito,
    tipoCampanha,
    sensibilidade_sms,
    sensibilidade_email,
    sensibilidade_push,
    sensibilidade_whatsapp,
    nomeConsumidor,
    documento,
  }: any = formik.values;

  const context = useAudience();

  const setFiltroConsulta = context.setFiltroConsulta;
  const setFiltroSegmentacao = context.setFiltroSegmentacao;

  useEffect(() => {
    setFiltroConsulta(getFilterData(formik.values));
  }, [formik.values, setFiltroConsulta]);

  useEffect(() => {
    setFiltroSegmentacao(formik.values);
  }, [formik.values, setFiltroSegmentacao]);

  useEffect(() => {
    return () => {
      formik.resetForm();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toast = useToast();

  const newSaveListProspecsPF = useMutation(
    async (param1: any) => {
      const response = await saveListProspecsPF(param1);
      return response;
    },
    {
      onSuccess: (response) => {
        toast.show("Audiência criada com sucesso!", {
          severity: "success",
        });
        selecionaLista(response);
        setShowFormikFilter(false);
        setState({ modalSalvarFiltro: false });
        dialog.show(
          "Inicie sua campanha",
          "Deseja iniciar uma campanha com essa audiência?",
          {
            onConfirmate: () => {
              navigate("/create-campaign");
              dialog.close();
            },
          }
        );
      },
      onError: () => {
        toast.show("Erro ao salvar audiência!", {
          severity: "error",
        });
      },
    }
  );

  const {
    data: listLojas = [], // listLojas
  } = useQuery(["filter component", "listStores"], async () => {
    const response = await listStores();
    const options = response.map((opt) => ({
      value: opt.id_loja,
      label: `${opt.nome_loja} ${opt.cidade} - ${opt.uf}`,
    }));
    return options;
  });

  const {
    data: listUFs = [], // listLojas
  } = useQuery(["filter component", "listUFsGet"], async () => {
    const response = await listUFsGet();
    return ordenaArray(response, "sigla");
  });

  const { data: listDDD = [] } = useQuery(
    "listDDD", // idStore
    listOverviewDDD
  );

  const { data: listTodasProfissao = [] } = useQuery(
    ["filter component", "listAllProfession"], // idStore
    async () => {
      const response = await listAllProfession(); // idStore
      return response;
    }
  );

  const { data: listCategoria1 = [] } = useQuery(
    ["filter component", "listAllCategories1"],
    async () => {
      const response = await listAllCategories1();
      return response;
    }
  );

  const { data: listCategoria2 = [] } = useQuery(
    ["filter component", "listAllCategories2"],
    async () => {
      const response = await listAllCategories2();
      return response;
    }
  );

  const { data: listCategoria3 = [] } = useQuery(
    ["filter component", "listAllCategories3"],
    async () => {
      const response = await listAllCategories3();
      return response;
    }
  );

  const { data: listCategoria4 = [] } = useQuery(
    ["filter component", "listAllCategories4"],
    async () => {
      const response = await listAllCategories4();
      return response;
    }
  );

  const { data: listCategoria5 = [] } = useQuery(
    ["filter component", "listAllCategories5"],
    async () => {
      const response = await listAllCategories5();
      return response;
    }
  );

  const { data: listCategoria6 = [] } = useQuery(
    ["filter component", "listAllCategories6"],
    async () => {
      const response = await listAllCategories6();
      return response;
    }
  );

  const { data: listCategoria7 = [] } = useQuery(
    ["filter component", "listAllCategories7"],
    async () => {
      const response = await listAllCategories7();
      return response;
    }
  );

  const { data: listCategoria8 = [] } = useQuery(
    ["filter component", "listAllCategories8"],
    async () => {
      const response = await listAllCategories8();
      return response;
    }
  );

  const { data: listCategoria9 = [] } = useQuery(
    ["filter component", "listAllCategories9"],
    async () => {
      const response = await listAllCategories9();
      return response;
    }
  );

  const { data: listCategoria10 = [] } = useQuery(
    ["filter component", "listAllCategories10"],
    async () => {
      const response = await listAllCategories10();
      return response;
    }
  );

  const consumptionProfile = useQuery(
    "consumptionProfile",
    listConsumptionProfile
  );

  const { data: listTagOrigem = [] } = useQuery(
    ["filter component", "listTagOrigin"],
    async () => {
      const response = await listTagOrigin();
      return [{ origem_tag: null, tipo_origem: "ORGÂNIGO" }, ...response];
    }
  );

  const { data: listMunicipios = [] } = useQuery(
    [
      "query filter",
      "listMunicipalities",
      {
        selectedEstados,
      },
    ],
    async () => {
      const response = await listMunicipalities(selectedEstados);
      const municipio = response.map((municipio) => ({
        value: municipio.id,
        label: `${municipio.microrregiao.mesorregiao.UF.sigla} - ${municipio.nome}`,
        cidade: municipio.nome,
      }));

      return ordenaArray(municipio, "label");
    },
    {
      enabled: Array.isArray(selectedEstados) && selectedEstados.length > 0,
    }
  );

  const { data: listBairros = [] } = useQuery(
    [
      "query filter",
      "listNeighborhoods",
      {
        selectedMunicipios,
      },
    ],
    async () => {
      const response = await listNeighborhoods(selectedMunicipios);
      const payload = response.map((bairro, value) => ({
        value,
        label: `${bairro.bairro} - ${bairro.cidade}`,
        bairro: bairro.bairro,
      }));

      return payload;
    },
    {
      enabled:
        Array.isArray(selectedMunicipios) && selectedMunicipios.length > 0,
    }
  );

  const [textToListDocuments, setTextToListDocuments] = useState(null);

  const {
    data: listDocumentos = [], // listLojas
  } = useQuery(
    ["filter component", "listAllDocuments", textToListDocuments],
    async () => {
      const response = await listAllDocuments(textToListDocuments);

      return response;
    },
    {
      enabled: !!textToListDocuments,
    }
  );

  const searchPeople = useCallback(() => {
    formik.setFieldValue("changeToRefetch", new Date().getTime());
  }, [formik]);

  const salvarFiltro = async () => {
    const { filtroSegmentacao } = context;
    const objParameters = {
      nome: nomeConsumidor,
      documento: documento,
      cidades: selectedMunicipios
        ? selectedMunicipios.map((municipio) => RemoveAcentos(municipio.cidade))
        : [],
      estados: selectedEstados
        ? selectedEstados.map((estado) => estado.value)
        : [],
      bairros: selectedBairros
        ? selectedBairros.map((bairro) => bairro.bairro)
        : [],
      ddd: selectedDDD ? selectedDDD.map((ddd) => ddd.DDD) : [],

      store: selectedStores ? selectedStores.map((str) => str.value) : [],
      faixaEtaria: faixaEtaria,
      percentualDesconto: percentualDesconto,
      genre: genre ? genre.split(",") : [],
      termometro: termometro ? termometro : [],
      tipoCampanha: tipoCampanha ? tipoCampanha : [],
      sensibilidade_sms: sensibilidade_sms ? sensibilidade_sms : [],
      sensibilidade_email: sensibilidade_email ? sensibilidade_email : [],
      sensibilidade_push: sensibilidade_push ? sensibilidade_push : [],
      sensibilidade_whatsapp: sensibilidade_whatsapp
        ? sensibilidade_whatsapp
        : [],
      status: status ? status : [],
      dataCadastroInicio: dataCadastroInicio
        ? format(dataCadastroInicio, "yyyy-MM-dd")
        : null,
      dataCadastroFim: dataCadastroFim
        ? format(dataCadastroFim, "yyyy-MM-dd")
        : null,
      dataCompraInicio: dataCompraInicio
        ? format(dataCompraInicio, "yyyy-MM-dd")
        : null,
      dataCompraFim: dataCompraFim ? format(dataCompraFim, "yyyy-MM-dd") : null,
      qtdeCompras: qtdeComprasInicio ? [qtdeComprasInicio, qtdeComprasFim] : [],
      valorCompras: valorComprasInicio
        ? [valorComprasInicio, valorComprasFim]
        : [],
      selectedProfissao: selectedProfissao
        ? selectedProfissao.map((pro) => pro.value)
        : [],
      selectedTagOrigem: selectedTagOrigem
        ? selectedTagOrigem.map((tag) => tag.origem_tag)
        : [],
      selectedDocumento: selectedDocumento
        ? selectedDocumento.map((doc) => doc.documento)
        : [],
      selectedMesNascimento: selectedMesNascimento
        ? selectedMesNascimento.map((mes) => mes.value)
        : [],
      celular: celular || celular === 0 ? celular : [],
      telefone: telefone || telefone === 0 ? telefone : [],
      endereco: endereco || endereco === 0 ? endereco : [],
      email: email || email === 0 ? email : [],

      categoria_1: categoria_1 ? categoria_1.map((grupo) => grupo.value) : [],
      categoria_2: categoria_2
        ? categoria_2.map((familia) => familia.value)
        : [],
      categoria_3: categoria_3
        ? categoria_3.map((condicao) => condicao.value)
        : [],
      categoria_4: categoria_4 ? categoria_4.map((cor) => cor.value) : [],
      categoria_5: categoria_5
        ? categoria_5.map((fornecedor) => fornecedor.value)
        : [],
      categoria_6: categoria_6
        ? categoria_6.map((colecao) => colecao.value)
        : [],
      categoria_7: categoria_7
        ? categoria_7.map((fornecedor) => fornecedor.value)
        : [],
      categoria_8: categoria_8
        ? categoria_8.map((colecao) => colecao.value)
        : [],
      categoria_9: categoria_9
        ? categoria_9.map((fornecedor) => fornecedor.value)
        : [],
      categoria_10: categoria_10
        ? categoria_10.map((colecao) => colecao.value)
        : [],
      categoria_11: categoria_11
        ? categoria_11.map((colecao) => colecao.value)
        : [],
      categoria_12: categoria_12
        ? categoria_12.map((colecao) => colecao.value)
        : [],
      n_categoria_1: n_categoria_1
        ? n_categoria_1.map((grupo) => grupo.value)
        : [],
      n_categoria_2: n_categoria_2
        ? n_categoria_2.map((familia) => familia.value)
        : [],
      n_categoria_3: n_categoria_3
        ? n_categoria_3.map((condicao) => condicao.value)
        : [],
      n_categoria_4: n_categoria_4 ? n_categoria_4.map((cor) => cor.value) : [],
      n_categoria_5: n_categoria_5
        ? n_categoria_5.map((fornecedor) => fornecedor.value)
        : [],
      n_categoria_6: n_categoria_6
        ? n_categoria_6.map((colecao) => colecao.value)
        : [],
      n_categoria_7: n_categoria_7
        ? n_categoria_7.map((fornecedor) => fornecedor.value)
        : [],
      n_categoria_8: n_categoria_8
        ? n_categoria_8.map((colecao) => colecao.value)
        : [],
      n_categoria_9: n_categoria_9
        ? n_categoria_9.map((fornecedor) => fornecedor.value)
        : [],
      n_categoria_10: n_categoria_10
        ? n_categoria_10.map((colecao) => colecao.value)
        : [],
      pesquisa_1: pesquisa_1
        ? pesquisa_1.map((pesquisa) => pesquisa.RESPOSTA)
        : [],
      pesquisa_2: pesquisa_2
        ? pesquisa_2.map((pesquisa) => pesquisa.RESPOSTA)
        : [],
      pesquisa_3: pesquisa_3
        ? pesquisa_3.map((pesquisa) => pesquisa.RESPOSTA)
        : [],
      pesquisa_4: pesquisa_4
        ? pesquisa_4.map((pesquisa) => pesquisa.RESPOSTA)
        : [],
      pesquisa_5: pesquisa_5
        ? pesquisa_5.map((pesquisa) => pesquisa.RESPOSTA)
        : [],
      ticketMedio: ticketMedioInicio ? [ticketMedioInicio, ticketMedioFim] : [],
      diasCadastro: [diasCadastroInicio, diasCadastroFim],
      diasCompra: [diasCompraInicio, diasCompraFim],
      cashback: cashbackInicio ? [cashbackInicio, cashbackFim] : [],
      dataInicioVencimentoCashback: dataInicioVencimentoCashback,
      dataFimVencimentoCashback: dataFimVencimentoCashback,
      diasVencimentoCashback: diasVencimentoCashback,
      aniversarioHoje: aniversarioHoje,
      aniversarioMes: aniversarioMes,
      nameList: state.filterName,
      idCluster: Boolean(state.clusterName)
        ? state.clusterName.ID_CLUSTER_AUDIENCIA
        : 10,
      namecluster: Boolean(state.clusterName) ? state.clusterName.NOME : null,
    };

    await newSaveListProspecsPF.mutateAsync({
      objParameters,
      filtroSegmentacao,
    });
  };

  const updateAllFormikValues = (obj) => {
    for (var name in obj) {
      formik.setFieldValue(name, obj[name]);
    }
  };

  const selecionaLista = (lista) => {
    if (lista) {
      const filtro_completo = JSON.parse(lista.filtro_completo);
      const filtro = JSON.parse(lista.filtro);
      const d = new Date();
      let time = d.getTime();
      context.setFiltroConsulta({
        ...filtro,
        idListProspectei: lista.idListProspectei,
        changeToRefetch: time,
      });
      context.setFiltroSegmentacao(filtro_completo);
      updateAllFormikValues(filtro_completo);
    } else {
      const d = new Date();
      let time = d.getTime();
      context.setFiltroConsulta({
        changeToRefetch: time,
      });
      context.setFiltroSegmentacao({});
    }

    context.setFiltroSelecionado(lista);
  };

  const onChange = (state, value) => {
    setState({ [state]: value });
  };

  return (
    <>
      {children}
      <Drawer
        classes={{
          paper: styles.drawer,
        }}
        variant="persistent"
        anchor="right"
        open={showFormikFilter}
      >
        <Stack spacing={4} marginBottom={9}>
          <Stack spacing={2}>
            <Stack
              direction="row"
              spacing={2}
              alignItems="center"
              justifyContent="space-between"
            >
              <Typography variant="h6" color="primary">
                Localização do consumidor
              </Typography>
              <IconButton onClick={() => setShowFormikFilter(false)}>
                <Close />
              </IconButton>
            </Stack>
            <Autocomplete
              fullWidth
              multiple
              size="small"
              label="Estados"
              options={listUFs.map((estado) => ({
                value: estado.sigla,
                label: estado.nome,
                id: estado.id,
              }))}
              getOptionLabel={(option) => option.label}
              value={selectedEstados}
              onChange={(_, value) => {
                changeFiltro("selectedEstados", value);
              }}
            />
            <Autocomplete
              value={selectedMunicipios}
              onChange={(_, value) => {
                changeFiltro("selectedMunicipios", value);
              }}
              disabled={selectedEstados ? !selectedEstados.length : true}
              options={listMunicipios}
              fullWidth
              multiple
              size="small"
              label="Cidades"
              getOptionLabel={(option) => option.label}
            />
            <Autocomplete
              value={selectedBairros}
              onChange={(_, value) => changeFiltro("selectedBairros", value)}
              disabled={selectedMunicipios ? !selectedMunicipios.length : true}
              multiple
              options={listBairros}
              fullWidth
              size="small"
              label="Bairros"
              getOptionLabel={(option) => option.label}
            />
            <Autocomplete
              fullWidth
              size="small"
              label="DDD"
              getOptionLabel={(option) => option.DDD}
              value={selectedDDD}
              onChange={(_, value) => changeFiltro("selectedDDD", value)}
              multiple
              options={listDDD}
            />
          </Stack>
          <Stack spacing={2}>
            <Typography variant="h6" color="primary">
              Características do consumidor
            </Typography>
            <TextField
              variant="outlined"
              size="small"
              label="Nome"
              onChange={({ target: { value } }) =>
                changeFiltro("nomeConsumidor", value)
              }
            />
            <Autocomplete
              fullWidth
              size="small"
              label="Documento"
              getOptionLabel={(option) => option.documento}
              multiple
              placeholder="Digite o CPF..."
              value={selectedDocumento}
              onInputChange={(_, text) => setTextToListDocuments(text)}
              onChange={(_, value) => changeFiltro("selectedDocumento", value)}
              options={listDocumentos}
            />
            <Autocomplete
              value={selectedMesNascimento}
              onChange={(_, value) =>
                changeFiltro("selectedMesNascimento", value)
              }
              options={MES}
              fullWidth
              size="small"
              label="Mês do aniversário"
              getOptionLabel={(option) => option.label}
              multiple
            />
            <Autocomplete
              value={selectedProfissao}
              onChange={(_, value) => changeFiltro("selectedProfissao", value)}
              multiple
              options={listTodasProfissao.map((profissao) => ({
                value: profissao.id_pessoa_profissao,
                label: profissao.descricao,
              }))}
              fullWidth
              size="small"
              label="Profissão"
              getOptionLabel={(option) => option.label}
            />
            <Autocomplete
              value={selectedTagOrigem}
              onChange={(_, value) => changeFiltro("selectedTagOrigem", value)}
              multiple
              options={listTagOrigem}
              fullWidth
              size="small"
              label="Tag origem"
              getOptionLabel={(option) => option.tipo_origem}
            />

            <Stack spacing={1}>
              <Typography>Faixa etária</Typography>

              <Slider
                size="small"
                color="primary"
                value={isEmpty(faixaEtaria) ? [0, 100] : faixaEtaria}
                onChange={(_, newValue) =>
                  changeFiltro("faixaEtaria", newValue)
                }
                valueLabelDisplay="auto"
                step={2}
                marks
                min={0}
                max={100}
              />
            </Stack>

            <Stack spacing={1}>
              <Typography>Data de cadastro</Typography>
              <Stack direction="row" spacing={2}>
                <DatePicker
                  label="De"
                  value={dataCadastroInicio}
                  onChange={(date) => {
                    changeFiltro("dataCadastroInicio", date);
                  }}
                  fullWidth
                  size="small"
                />

                <DatePicker
                  label="Até"
                  value={dataCadastroFim}
                  onChange={(date) => changeFiltro("dataCadastroFim", date)}
                  fullWidth
                  size="small"
                />
              </Stack>
            </Stack>
            <Stack spacing={1}>
              <Typography>Gênero</Typography>
              <Stack direction="row" spacing={2}>
                <Chip
                  variant={genre === null ? "filled" : "outlined"}
                  label="Todos"
                  clickable
                  onClick={() => changeFiltro("genre", null)}
                  color="primary"
                />
                <Chip
                  variant={
                    genre !== null && genre === "Feminino,F"
                      ? "filled"
                      : "outlined"
                  }
                  label="Feminino"
                  clickable
                  onClick={() => changeFiltro("genre", "Feminino,F")}
                  color="primary"
                />
                <Chip
                  variant={
                    genre !== null && genre === "Masculino,M"
                      ? "filled"
                      : "outlined"
                  }
                  label="Masculino"
                  clickable
                  onClick={() => changeFiltro("genre", "Masculino,M")}
                  color="primary"
                />
              </Stack>
            </Stack>
            <Stack spacing={1}>
              <Typography>Status</Typography>
              <Stack direction="row" spacing={2}>
                <Chip
                  clickable
                  variant={status === null ? "filled" : "outlined"}
                  label="Todos"
                  onClick={() => changeFiltro("status", null)}
                  color="primary"
                />
                <Chip
                  clickable
                  variant={
                    status !== null && status === 1 ? "filled" : "outlined"
                  }
                  label="Ativo"
                  onClick={() => changeFiltro("status", 1)}
                  color="primary"
                />
                <Chip
                  clickable
                  variant={
                    status !== null && status === 2 ? "filled" : "outlined"
                  }
                  label="Inativo"
                  onClick={() => changeFiltro("status", 2)}
                  color="primary"
                />
              </Stack>
            </Stack>
            <Stack spacing={1}>
              <Typography>Tem email ?</Typography>
              <Stack direction="row" spacing={2}>
                {SN.map((mail, index) => (
                  <Chip
                    clickable
                    variant={email === mail.value ? "filled" : "outlined"}
                    color="primary"
                    key={index.toString()}
                    label={mail.label}
                    onClick={() => changeFiltro("email", mail.value)}
                  />
                ))}
              </Stack>
            </Stack>
            <Stack spacing={1}>
              <Typography>Tem telefone ?</Typography>

              <Stack direction="row" spacing={2}>
                {SN.map((tell, index) => (
                  <Chip
                    clickable
                    variant={telefone === tell.value ? "filled" : "outlined"}
                    color="primary"
                    key={index.toString()}
                    label={tell.label}
                    onClick={() => changeFiltro("telefone", tell.value)}
                  />
                ))}
              </Stack>
            </Stack>
            <Stack spacing={1}>
              <Typography>Tem celular ?</Typography>
              <Stack direction="row" spacing={2}>
                {SN.map((cell, index) => (
                  <Chip
                    clickable
                    variant={celular === cell.value ? "filled" : "outlined"}
                    color="primary"
                    key={index.toString()}
                    label={cell.label}
                    onClick={() => changeFiltro("celular", cell.value)}
                  />
                ))}
              </Stack>
            </Stack>
            <Stack spacing={1}>
              <Typography>Tem endereço ?</Typography>
              <Stack direction="row" spacing={2}>
                {SN.map((end, index) => (
                  <Chip
                    clickable
                    variant={endereco === end.value ? "filled" : "outlined"}
                    color="primary"
                    key={index.toString()}
                    label={end.label}
                    onClick={() => changeFiltro("endereco", end.value)}
                  />
                ))}
              </Stack>
            </Stack>
            <Stack spacing={1}>
              <Typography>Canal de preferência</Typography>
              <Stack direction="row" spacing={2}>
                <Chip
                  variant={canalPreferecia === null ? "filled" : "outlined"}
                  label="Todos"
                  clickable
                  onClick={() => changeFiltro("canalPreferecia", null)}
                  color="primary"
                />
                <Chip
                  variant={canalPreferecia === "Email" ? "filled" : "outlined"}
                  label="Email"
                  clickable
                  onClick={() => changeFiltro("canalPreferecia", "Email")}
                  color="primary"
                />
                <Chip
                  variant={canalPreferecia === "sms" ? "filled" : "outlined"}
                  label="SMS"
                  clickable
                  onClick={() => changeFiltro("canalPreferecia", "sms")}
                  color="primary"
                />
                <Chip
                  variant={
                    canalPreferecia === "whatsapp" ? "filled" : "outlined"
                  }
                  label="WhatsApp"
                  clickable
                  onClick={() => changeFiltro("canalPreferecia", "whatsapp")}
                  color="primary"
                />
              </Stack>
            </Stack>
            <Stack spacing={1}>
              <Typography>Canal aceito</Typography>
              <Stack direction="row" spacing={2}>
                <Chip
                  variant={canalAceito === null ? "filled" : "outlined"}
                  label="Todos"
                  clickable
                  onClick={() => changeFiltro("canalAceito", null)}
                  color="primary"
                />
                <Chip
                  variant={canalAceito === "email" ? "filled" : "outlined"}
                  label="Email"
                  clickable
                  onClick={() => changeFiltro("canalAceito", "email")}
                  color="primary"
                />
                <Chip
                  variant={canalAceito === "sms" ? "filled" : "outlined"}
                  label="SMS"
                  clickable
                  onClick={() => changeFiltro("canalAceito", "sms")}
                  color="primary"
                />
                <Chip
                  variant={canalAceito === "whatsapp" ? "filled" : "outlined"}
                  label="WhatsApp"
                  clickable
                  onClick={() => changeFiltro("canalAceito", "whatsapp")}
                  color="primary"
                />
              </Stack>
            </Stack>
          </Stack>
          <Stack spacing={2}>
            <Typography variant="h6" color="primary">
              Recência, freqüência e valor
            </Typography>
            <Autocomplete
              fullWidth
              size="small"
              label="Lojas"
              options={listLojas}
              multiple
              getOptionLabel={(option) => option.label}
              value={selectedStores}
              onChange={(_, value) => {
                changeFiltro("selectedStores", value);
              }}
            />
            <Stack spacing={1}>
              <Typography>Data da última compra</Typography>
              <Stack direction="row" spacing={2}>
                <DatePicker
                  value={dataCompraInicio}
                  onChange={(date) => changeFiltro("dataCompraInicio", date)}
                  label="De"
                  fullWidth
                  size="small"
                />

                <DatePicker
                  label="Até"
                  value={dataCompraFim}
                  onChange={(date) => changeFiltro("dataCompraFim", date)}
                  fullWidth
                  size="small"
                />
              </Stack>
            </Stack>
            <Stack spacing={1}>
              <Typography>Quantidade de compras</Typography>
              <Stack direction="row" spacing={2}>
                <TextField
                  type="number"
                  label="De"
                  onChange={({ target }) => {
                    changeFiltro(
                      "qtdeComprasInicio",
                      Number(target.value) < 0 ? 0 : target.value
                    );
                  }}
                  value={qtdeComprasInicio}
                  size="small"
                />

                <TextField
                  type="number"
                  label="Até"
                  onChange={({ target }) => {
                    changeFiltro(
                      "valorComprasFim",
                      Number(target.value) < 0 ? 0 : target.value
                    );
                  }}
                  value={valorComprasFim}
                  size="small"
                />
              </Stack>
            </Stack>
            <Stack spacing={1}>
              <Typography>Valor gasto</Typography>
              <Stack direction="row" spacing={2}>
                <TextField
                  type="number"
                  label="De"
                  onChange={({ target }) => {
                    changeFiltro(
                      "valorComprasInicio",
                      Number(target.value) < 0 ? 0 : target.value
                    );
                  }}
                  value={valorComprasInicio}
                  size="small"
                />

                <TextField
                  type="number"
                  label="Até"
                  onChange={({ target }) => {
                    changeFiltro(
                      "qtdeComprasFim",
                      Number(target.value) < 0 ? 0 : target.value
                    );
                  }}
                  value={qtdeComprasFim}
                  size="small"
                />
              </Stack>
            </Stack>
            <Stack spacing={1}>
              <Typography>Ticket médio</Typography>
              <Stack direction="row" spacing={2}>
                <TextField
                  type="number"
                  label="De"
                  onChange={({ target }) => {
                    changeFiltro(
                      "ticketMedioInicio",
                      Number(target.value) < 0 ? 0 : target.value
                    );
                  }}
                  value={ticketMedioInicio}
                  size="small"
                />

                <TextField
                  type="number"
                  label="Até"
                  onChange={({ target }) => {
                    changeFiltro(
                      "ticketMedioFim",
                      Number(target.value) < 0 ? 0 : target.value
                    );
                  }}
                  value={ticketMedioFim}
                  size="small"
                />
              </Stack>
            </Stack>
            <Stack spacing={1}>
              <Typography>Percentual de desconto</Typography>
              <Slider
                size="small"
                color="primary"
                value={
                  isEmpty(percentualDesconto) ? [0, 100] : percentualDesconto
                }
                onChange={(_, newValue) =>
                  changeFiltro("percentualDesconto", newValue)
                }
                valueLabelDisplay="auto"
                step={10}
                marks
                min={0}
                max={100}
              />
            </Stack>
            <Stack spacing={1}>
              <Typography>Termômetro</Typography>
              <Stack direction="row" spacing={2}>
                {TERMOMETRO.map((term, index) => (
                  <Chip
                    key={index}
                    label={term.label}
                    onClick={() => changeFiltro("termometro", term.value)}
                    color="primary"
                    clickable
                    variant={termometro === term.value ? "filled" : "outlined"}
                  />
                ))}
              </Stack>
            </Stack>
          </Stack>
          <Stack spacing={2}>
            <Typography variant="h6" color="primary">
              Automações
            </Typography>
            <Stack spacing={1}>
              <Typography>Aniversariantes de hoje</Typography>
              <Stack direction="row" spacing={2}>
                {SN.slice(1, 3).map((niver, index) => (
                  <Chip
                    clickable
                    variant={
                      aniversarioHoje === niver.value ? "filled" : "outlined"
                    }
                    color="primary"
                    key={index}
                    label={niver.label}
                    onClick={() => changeFiltro("aniversarioHoje", niver.value)}
                  />
                ))}
              </Stack>
            </Stack>
            <Stack spacing={1}>
              <Typography>Aniversariantes do mês</Typography>
              <Stack direction="row" spacing={2}>
                {SN.slice(1, 3).map((niver, index) => (
                  <Chip
                    clickable
                    variant={
                      aniversarioMes === niver.value ? "filled" : "outlined"
                    }
                    color="primary"
                    key={index}
                    label={niver.label}
                    onClick={() => changeFiltro("aniversarioMes", niver.value)}
                  />
                ))}
              </Stack>
            </Stack>
            <Stack spacing={1}>
              <Typography>Dias do cadastro</Typography>
              <Stack direction="row" spacing={2}>
                <TextField
                  type="number"
                  label="De"
                  onChange={({ target }) => {
                    changeFiltro(
                      "diasCadastroInicio",
                      Number(target.value) < 0 ? 0 : target.value
                    );
                  }}
                  value={diasCadastroInicio}
                  size="small"
                />

                <TextField
                  type="number"
                  label="Até"
                  onChange={({ target }) => {
                    changeFiltro(
                      "diasCadastroFim",
                      Number(target.value) < 0 ? 0 : target.value
                    );
                  }}
                  value={diasCadastroFim}
                  size="small"
                />
              </Stack>
            </Stack>
            <Stack spacing={1}>
              <Typography>Dias da última compra</Typography>
              <Stack direction="row" spacing={2}>
                <TextField
                  type="number"
                  label="De"
                  onChange={({ target }) => {
                    changeFiltro(
                      "diasCompraInicio",
                      Number(target.value) < 0 ? 0 : target.value
                    );
                  }}
                  value={diasCompraInicio}
                  size="small"
                />

                <TextField
                  type="number"
                  label="Até"
                  onChange={({ target }) => {
                    changeFiltro(
                      "diasCompraFim",
                      Number(target.value) < 0 ? 0 : target.value
                    );
                  }}
                  value={diasCompraFim}
                  size="small"
                />
              </Stack>
            </Stack>
          </Stack>
          {!isEmpty(consumptionProfile.data) && (
            <Stack spacing={2}>
              <Typography variant="h6" color="primary">
                Características de Pesquisa
              </Typography>
              {map(consumptionProfile.data, (consumer) => (
                <Autocomplete
                  key={consumer.label}
                  fullWidth
                  size="small"
                  label={`Características ${consumer.label}`}
                  getOptionLabel={(option) => option.RESPOSTA}
                  value={formik.values[`pesquisa_${consumer.label}`]}
                  onChange={(_, value) => {
                    changeFiltro(`pesquisa_${consumer.label}`, value);
                  }}
                  multiple
                  options={consumer.options}
                />
              ))}
            </Stack>
          )}

          <Stack spacing={2}>
            <Typography variant="h6" color="primary">
              Características do Produto
            </Typography>
            <Grid container spacing={2}>
              <Grid xs={6}>
                <Stack spacing={2}>
                  <Typography textAlign="center" variant="body1">
                    Compraram
                  </Typography>
                  <Autocomplete
                    fullWidth
                    size="small"
                    label="Características 1"
                    getOptionLabel={(option) => option.label}
                    onChange={(_, value) => {
                      changeFiltro("categoria_1", value);
                    }}
                    value={categoria_1}
                    multiple
                    options={map(listCategoria1, (grupo) => ({
                      value: grupo.categoria_1,
                      label: grupo.desc_categoria_1,
                    }))}
                  />
                  {!isEmpty(listCategoria2) && (
                    <Autocomplete
                      fullWidth
                      size="small"
                      label="Características 2"
                      getOptionLabel={(option) => option.label}
                      onChange={(_, value) => {
                        changeFiltro("categoria_2", value);
                      }}
                      value={categoria_2}
                      multiple
                      options={map(listCategoria2, (grupo) => ({
                        value: grupo.categoria_2,
                        label: grupo.desc_categoria_2,
                      }))}
                    />
                  )}
                  {!isEmpty(listCategoria3) && (
                    <Autocomplete
                      fullWidth
                      size="small"
                      label="Características 3"
                      getOptionLabel={(option) => option.label}
                      onChange={(_, value) => {
                        changeFiltro("categoria_3", value);
                      }}
                      value={categoria_3}
                      multiple
                      options={map(listCategoria3, (grupo) => ({
                        value: grupo.categoria_3,
                        label: grupo.desc_categoria_3,
                      }))}
                    />
                  )}
                  {!isEmpty(listCategoria4) && (
                    <Autocomplete
                      fullWidth
                      size="small"
                      label="Características 4"
                      getOptionLabel={(option) => option.label}
                      onChange={(_, value) => {
                        changeFiltro("categoria_4", value);
                      }}
                      value={categoria_4}
                      multiple
                      options={map(listCategoria4, (grupo) => ({
                        value: grupo.categoria_4,
                        label: grupo.desc_categoria_4,
                      }))}
                    />
                  )}
                  {!isEmpty(listCategoria5) && (
                    <Autocomplete
                      fullWidth
                      size="small"
                      label="Características 5"
                      getOptionLabel={(option) => option.label}
                      onChange={(_, value) => {
                        changeFiltro("categoria_5", value);
                      }}
                      value={categoria_5}
                      multiple
                      options={map(listCategoria5, (grupo) => ({
                        value: grupo.categoria_5,
                        label: grupo.desc_categoria_5,
                      }))}
                    />
                  )}
                  {!isEmpty(listCategoria6) && (
                    <Autocomplete
                      fullWidth
                      size="small"
                      label="Características 6"
                      getOptionLabel={(option) => option.label}
                      onChange={(_, value) => {
                        changeFiltro("categoria_6", value);
                      }}
                      value={categoria_6}
                      multiple
                      options={map(listCategoria6, (grupo) => ({
                        value: grupo.categoria_6,
                        label: grupo.desc_categoria_6,
                      }))}
                    />
                  )}
                  {!isEmpty(listCategoria7) && (
                    <Autocomplete
                      fullWidth
                      size="small"
                      label="Características 7"
                      getOptionLabel={(option) => option.label}
                      onChange={(_, value) => {
                        changeFiltro("categoria_7", value);
                      }}
                      value={categoria_7}
                      multiple
                      options={map(listCategoria7, (grupo) => ({
                        value: grupo.categoria_7,
                        label: grupo.desc_categoria_7,
                      }))}
                    />
                  )}
                  {!isEmpty(listCategoria8) && (
                    <Autocomplete
                      fullWidth
                      size="small"
                      label="Características 8"
                      getOptionLabel={(option) => option.label}
                      onChange={(_, value) => {
                        changeFiltro("categoria_8", value);
                      }}
                      value={categoria_8}
                      multiple
                      options={map(listCategoria8, (grupo) => ({
                        value: grupo.categoria_8,
                        label: grupo.desc_categoria_8,
                      }))}
                    />
                  )}
                  {!isEmpty(listCategoria9) && (
                    <Autocomplete
                      fullWidth
                      size="small"
                      label="Características 9"
                      getOptionLabel={(option) => option.label}
                      onChange={(_, value) => {
                        changeFiltro("categoria_9", value);
                      }}
                      value={categoria_9}
                      multiple
                      options={map(listCategoria9, (grupo) => ({
                        value: grupo.categoria_9,
                        label: grupo.desc_categoria_9,
                      }))}
                    />
                  )}
                  {!isEmpty(listCategoria10) && (
                    <Autocomplete
                      fullWidth
                      size="small"
                      label="Características 10"
                      getOptionLabel={(option) => option.label}
                      onChange={(_, value) => {
                        changeFiltro("categoria_10", value);
                      }}
                      value={categoria_10}
                      multiple
                      options={map(listCategoria10, (grupo) => ({
                        value: grupo.categoria_10,
                        label: grupo.desc_categoria_10,
                      }))}
                    />
                  )}
                </Stack>
              </Grid>
              <Grid xs={6}>
                <Stack spacing={2}>
                  <Typography textAlign="center" variant="body1">
                    Não compraram
                  </Typography>
                  <Autocomplete
                    fullWidth
                    size="small"
                    label="Características 1"
                    getOptionLabel={(option) => option.label}
                    onChange={(_, value) => {
                      changeFiltro("n_categoria_1", value);
                    }}
                    value={n_categoria_1}
                    multiple
                    options={map(listCategoria1, (grupo) => ({
                      value: grupo.categoria_1,
                      label: grupo.desc_categoria_1,
                    }))}
                  />
                  {!isEmpty(listCategoria2) && (
                    <Autocomplete
                      fullWidth
                      size="small"
                      label="Características 2"
                      getOptionLabel={(option) => option.label}
                      onChange={(_, value) => {
                        changeFiltro("n_categoria_2", value);
                      }}
                      value={n_categoria_2}
                      multiple
                      options={map(listCategoria2, (grupo) => ({
                        value: grupo.categoria_2,
                        label: grupo.desc_categoria_2,
                      }))}
                    />
                  )}
                  {!isEmpty(listCategoria3) && (
                    <Autocomplete
                      fullWidth
                      size="small"
                      label="Características 3"
                      getOptionLabel={(option) => option.label}
                      onChange={(_, value) => {
                        changeFiltro("n_categoria_3", value);
                      }}
                      value={n_categoria_3}
                      multiple
                      options={map(listCategoria3, (grupo) => ({
                        value: grupo.categoria_3,
                        label: grupo.desc_categoria_3,
                      }))}
                    />
                  )}
                  {!isEmpty(listCategoria4) && (
                    <Autocomplete
                      fullWidth
                      size="small"
                      label="Características 4"
                      getOptionLabel={(option) => option.label}
                      onChange={(_, value) => {
                        changeFiltro("n_categoria_4", value);
                      }}
                      value={n_categoria_4}
                      multiple
                      options={map(listCategoria4, (grupo) => ({
                        value: grupo.categoria_4,
                        label: grupo.desc_categoria_4,
                      }))}
                    />
                  )}
                  {!isEmpty(listCategoria5) && (
                    <Autocomplete
                      fullWidth
                      size="small"
                      label="Características 5"
                      getOptionLabel={(option) => option.label}
                      onChange={(_, value) => {
                        changeFiltro("n_categoria_5", value);
                      }}
                      value={n_categoria_5}
                      multiple
                      options={map(listCategoria5, (grupo) => ({
                        value: grupo.categoria_5,
                        label: grupo.desc_categoria_5,
                      }))}
                    />
                  )}
                  {!isEmpty(listCategoria6) && (
                    <Autocomplete
                      fullWidth
                      size="small"
                      label="Características 6"
                      getOptionLabel={(option) => option.label}
                      onChange={(_, value) => {
                        changeFiltro("n_categoria_6", value);
                      }}
                      value={n_categoria_6}
                      multiple
                      options={map(listCategoria6, (grupo) => ({
                        value: grupo.categoria_6,
                        label: grupo.desc_categoria_6,
                      }))}
                    />
                  )}
                  {!isEmpty(listCategoria7) && (
                    <Autocomplete
                      fullWidth
                      size="small"
                      label="Características 7"
                      getOptionLabel={(option) => option.label}
                      onChange={(_, value) => {
                        changeFiltro("n_categoria_7", value);
                      }}
                      value={n_categoria_7}
                      multiple
                      options={map(listCategoria7, (grupo) => ({
                        value: grupo.categoria_7,
                        label: grupo.desc_categoria_7,
                      }))}
                    />
                  )}
                  {!isEmpty(listCategoria8) && (
                    <Autocomplete
                      fullWidth
                      size="small"
                      label="Características 8"
                      getOptionLabel={(option) => option.label}
                      onChange={(_, value) => {
                        changeFiltro("n_categoria_8", value);
                      }}
                      value={n_categoria_8}
                      multiple
                      options={map(listCategoria8, (grupo) => ({
                        value: grupo.categoria_8,
                        label: grupo.desc_categoria_8,
                      }))}
                    />
                  )}
                  {!isEmpty(listCategoria9) && (
                    <Autocomplete
                      fullWidth
                      size="small"
                      label="Características 9"
                      getOptionLabel={(option) => option.label}
                      onChange={(_, value) => {
                        changeFiltro("n_categoria_9", value);
                      }}
                      value={n_categoria_9}
                      multiple
                      options={map(listCategoria9, (grupo) => ({
                        value: grupo.categoria_9,
                        label: grupo.desc_categoria_9,
                      }))}
                    />
                  )}
                  {!isEmpty(listCategoria10) && (
                    <Autocomplete
                      fullWidth
                      size="small"
                      label="Características 10"
                      getOptionLabel={(option) => option.label}
                      onChange={(_, value) => {
                        changeFiltro("n_categoria_10", value);
                      }}
                      value={n_categoria_10}
                      multiple
                      options={map(listCategoria10, (grupo) => ({
                        value: grupo.categoria_10,
                        label: grupo.desc_categoria_10,
                      }))}
                    />
                  )}
                </Stack>
              </Grid>
            </Grid>
          </Stack>
        </Stack>
        <Stack
          className={styles.drawerAction}
          direction="row"
          justifyContent="space-between"
        >
          <Stack direction="row" spacing={2}>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => {
                formik.resetForm();
              }}
            >
              Limpar
            </Button>
            <Button variant="outlined" color="primary" onClick={searchPeople}>
              Aplicar
            </Button>
          </Stack>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setState({ modalSalvarFiltro: true })}
          >
            Salvar
          </Button>
        </Stack>
      </Drawer>

      <DialogFilterSave
        loadingFilter={newSaveListProspecsPF.isLoading}
        open={state.modalSalvarFiltro}
        onClose={() => setState({ modalSalvarFiltro: false })}
        onChange={(state, value) => onChange(state, value)}
        onSave={() => salvarFiltro()}
      />
    </>
  );
}

export default Filtro;
